import {
    CANDIDATE_EDUCATION_UPDATE_REQUEST,
    CANDIDATE_EDUCATION_UPDATE_SUCCESS,
    CANDIDATE_EDUCATION_UPDATE_FAIL,
} from "../constants/AuthConstant";
  
  const initialState = {
    loading: false,
    result: null,
    error: "",
  };
  
  const CandidateEducationReducer = (state = initialState, action) => {
    switch (action.type) {
      case CANDIDATE_EDUCATION_UPDATE_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case CANDIDATE_EDUCATION_UPDATE_SUCCESS:
        return {
          ...state,
          result: action.result.data,
          loading: false,
          msg: action.msg,
        };
      case CANDIDATE_EDUCATION_UPDATE_FAIL:
        return {
          ...state,
          error: action.error,
          loading: false,
          msg: action.msg,
        };
  
      default:
        return state;
    }
  };
  
  export default CandidateEducationReducer;